import Select from 'antd/es/select';
import styled, { css } from 'styled-components';
export const StyledSelect = styled(Select) `
  &.ant-select-multiple.ant-select-lg {
    padding-block: ${({ theme }) => theme.appearance.spacing * 0.5}px;
    .ant-select-selection-overflow {
      gap: ${({ theme }) => theme.appearance.spacing * 0.5}px;
    }
    .ant-select-selection-overflow-item {
      overflow: hidden;
      & > span {
        overflow: hidden;
      }
    }
    .ant-select-selection-overflow-item-suffix {
      margin-block: 0;
      min-height: 20px;
    }
  }
  &.ant-select {
    .ant-select-selector {
      ${({ $noPadding }) => $noPadding
    ? css `
              padding-inline-start: 0;
            `
    : undefined}
    }
  }
`;
